import React, { createContext, useEffect, useState } from "react";
import {
  Route,
  Routes,
  BrowserRouter,
  Link,
  useNavigate,
  HashRouter
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/styles/styles.css";
import Home from "./pages/home/Home";
import Messages from "./pages/Message/Messages";
import Vaccancy from "./pages/Vaccancy/Vaccancy";
import LoginPage from "./pages/login/LoginPage";
import UnlockedProfile from "./pages/UnlockedProfiles/UnlockedProfile";
import MainProfile from "./pages/Profiles/MainProfile";
import MyLists from "./pages/Notification/MyLists";
import HeaderAfterLogin from "./common/HeaderAfterLogin";
import HeaderBeforeLogin from "./common/HeaderBeforeLogin";
import Footer from "./common/Footer";
import PostForm from "./pages/PostVaccancy/PostForm";
// import Successfully from "./common/Successfully";
// import NoVaccancy from "./common/NoVaccancy";
import AppliedCandidates from "./pages/Vaccancy/AppliedCandidates";
import Subcription from "./pages/subcription/Subcription";
// import ApplicantsDetails from "./pages/Vaccancy/ApplicantsDetails";
import PostSuccess from "./common/PostSuccess";
import RecommendedProfile from "./pages/Recommende-profile/RecommendedProfile";
// import PaymentSuccess from "./pages/Notification/PaymentSuccessPopup";
import Calendar from "./pages/Vaccancy/Calendar";
import Subuser from "./pages/Notification/Subuser";
// import RecruiterHome from "./Jobseeker/JobseekerHome";
import Header from "./Jobseeker/Header";
import RecruiterFooter from "./Jobseeker/JobseekerFooter";
// import Myob from "./Jobseeker/Myjob/Myob";
// import JobseekerLogin from "./Jobseeker/Login/JobseekerLogin";
import HeaderSimple from "./Jobseeker/HeaderSimple";
// import JobseekerLoginPage from "./Jobseeker/Login/JobseekerLoginPage";
// import JobseekerMessage from "./Jobseeker/Message/JobseekerMessage";
// import Profile from "./Jobseeker/Profile/Profile";
// import JobseekerCalendar from "./Jobseeker/Myjob/Calender";
import Registration from "./common/Registration";
import ContactSupport from "./pages/Profiles/ContectSupport";
// import ForgetPassword from "./pages/login/ForgotPassword";
// import SearchResult from "./Jobseeker/Popup/SearchResult";
import Settings from "./pages/login/Settings";
import Privacy_policies from "./pages/home/component/Privacy&Policies";
import HireWithTimeSheet from "./pages/Vaccancy/HireWithTimeSheet ";
import Applicant_hiring from "./pages/Vaccancy/Applicant_hiring";
import { getData } from "./Service/ApiMethod";
import { Credit_BALANCE } from "./Service/service";
// import Landing_Page from "./pages/Landing-page/Landing_page";
// import PaymentPage from "./pages/Notification/PaymentPage";
// import SharedBlackScreen from "./pages/home/component/SharedBlackscreen";
import LandingPage from "./pages/Landing-page/LandingPage";
import MapView from "./pages/home/component/MapView";
import StoredMsg from "./pages/Message/StoredMsg";
import Searchscreen from "./pages/home/Searchscreen";
import Candidatesearch from "./pages/home/Candidatesearch";
import Forapp from "./pages/home/Forapp";
import Seekeraccountdelete from "./pages/login/Seekeraccountdelete";

const credit_coin = createContext()
const coinState = createContext()
const UserContext = createContext()
const candata = createContext()
const foCredit = createContext()

function App() {


  // useEffect(() => {
  //   // Delay the scroll action by 5 seconds (5000 milliseconds)
  //   const scrollTimeout = setTimeout(() => {
  //     // Scroll to the top of the page
  //     window.scrollTo(0, 0);
  //   }, 2000);

  //   // Clear the timeout when the component unmounts to prevent unnecessary scroll
  //   return () => clearTimeout(scrollTimeout);
  // }, []);
  // const [latitude, setLatitude] = useState();
  // const [longitude, setLongitude] = useState();
  const [creditBalance, setCreditBalance] = useState()
  const [updatedCoins, setUpdatedCoins] = useState(false)
  const [user, setUser] = useState(false);
  const [newData, setNewData] = useState(false)




  const getCreditBalance = () => {
    getData(Credit_BALANCE)
      .then((response) => response.json())
      .then((res) => {
        setCreditBalance(res.data?.credit_balance_history[0])
        console.log('credit_balanceResponse', res.data?.credit_balance_history[0])
      })
      .catch((err) => {
        console.log("Error ", err);
      });
  }
  console.log('credit coin number', creditBalance)

  useEffect(() => {
    console.log("sddd1");
    getCreditBalance()
    clearCacheData()
  }, [])
  const clearCacheData = () => {
    // Fetch your assets with a unique query parameter (cache busting)
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      scripts[i].src = scripts[i].src + '?v=' + Date.now();
      console.log(scripts[i].src,"checking")
    }

    // const links = document.getElementsByTagName('link');
    // for (let i = 0; i < links.length; i++) {
    //   links[i].href = links[i].href + '?v=' + Date.now();
    //   console.log( links[i].href,"checking1")
    // }

    // Inform user that cache has been cleared
    console.log("Complete Cache Cleared");
  };






  useEffect(() => {
    console.log("sddd2");
    getCreditBalance()
  }, [updatedCoins])

  useEffect(() => {
    console.log("sddd3");
    getCreditBalance()
  }, [newData])
  return (
    <>
      {/* <LandingPage /> */}

      <UserContext.Provider value={{ user, setUser }}>
        <credit_coin.Provider value={creditBalance} >
          <foCredit.Provider value={getCreditBalance}>
            <coinState.Provider value={setUpdatedCoins}>
              <candata.Provider value={{ newData, setNewData }}>
                <HashRouter>
                  <Routes>
                    <Route exact path="/" element={ScreensBeforeLogin(<LoginPage />)} />
                    <Route
                      path="/registration"
                      element={ScreensBeforeLogin(<Registration />)}
                    />
                    <Route

                      path="/map"

                      element={ScreensBeforeLogin(<MapView />)}
                    />
                    <Route path="/home" element={ScreensAfterLogin(<Home />)} />
                    <Route path="/vaccancy" element={(<Vaccancy />)} />
                    <Route
                      path="/post-vaccancy"
                      element={(<PostForm />)}
                    />
                    <Route
                      path="/applicants/:userid"
                      element={ScreensAfterLogin(<AppliedCandidates />)}
                    />
                    <Route path="/vaccancy-posted" element={<AppliedCandidates />} />
                    <Route
                      path="/hire-with-timesheet"
                      element={ScreensAfterLogin(<HireWithTimeSheet />)}
                    />
                    <Route
                      path="/recommended-profiles"
                      element={(<RecommendedProfile />)}
                    />
                    <Route
                      path="/unlock-profiles"
                      element={(<UnlockedProfile />)}
                    />
                    <Route
                      path="/subcription"
                      element={ScreensAfterLogin(<Subcription />)}
                    />
                    <Route
                      path="/search-list"
                      element={(<Searchscreen />)}
                    />
                    <Route path="/message" element={<Messages />} />
                    <Route
                      path="/MainProfile"
                      element={(<MainProfile />)}
                    />
                    <Route path="/mylists" element={(<MyLists />)} />
                    <Route path="/subusers" element={ScreensAfterLogin(<Subuser />)} />
                    <Route

                      path="/recomended-msgs"

                      element={ScreensAfterLogin(<StoredMsg />)}

                    />
                    <Route
                      path="/jobseeker-settings"
                      element={ScreensAfterLogin(<Settings />)}
                    />
                    <Route
                      path="/privacy_policies"
                      element={ScreensAfterLogin(<Privacy_policies />)}
                    />
                    <Route
                      path="/contact-support"
                      element={(<ContactSupport />)}
                    />
                    <Route
                      path="/hire-details"
                      element={ScreensAfterLogin(<Calendar />)}
                    />
                    <Route
                      path="/post-success"
                      element={ScreensAfterLogin(<PostSuccess />)}
                    />
                    <Route
                      path="/candidate-search-list"
                      element={(<Candidatesearch />)}
                    />
                    <Route
                      path="/hiring-details"
                      element={ScreensAfterLogin(<Applicant_hiring />)}
                    />
                    <Route
                      path="/forapp-check"
                      element={<Forapp />}
                    />
                    {/* 
    
         
         
        
                      
                    */}
                    {/* <Route exact path="/home" element={ScreensAfterLogin(<Home

                  />)} />
                 
                  <Route path="/forgetpassword" element={<ForgetPassword />} />
                
                 
                  <Route path="/home" element={ScreensAfterLogin(<Home />)} />
                  <Route path="/home" element={ScreensAfterLogin(<Home />)} />
                 
               
                 
              
                  
                  <Route
                    path="/success"
                    element={ScreensAfterLogin(<Successfully />)}
                  />
                  <Route path="/no-data" element={ScreensAfterLogin(<NoVaccancy />)} />
                  <Route
                    path="/applicants-details"
                    element={ScreensAfterLogin(<ApplicantsDetails />)}
                  />
                
                
                  
                 
                  <Route
                    path="/payment-success"
                    element={ScreensAfterLogin(<PaymentSuccess />)}
                  />
                  <Route
                    path="/credit"
                    element={ScreensAfterLogin(<PaymentPage />)}>

                  </Route>
                 
                 */}



                    {/* <Route
            path="/candidateNearMeList"
            element={ScreensAfterLogin(<CandidateNearMeList/>)}
          /> */}
                    {/* <Route
                    path="/unlock-profiles"
                    element={(<UnlockedProfile />)}
                  />
                  <Route path="/Calender" element={ScreensAfterLogin(<Calendar />)} />
                  
               
                  <Route
                    path="/jobseeker-login"
                    element={ScreenJobseekerBeforeLogin(<JobseekerLoginPage />)}
                  />
                  <Route
                    path="/jobs/:id" element={(<SharedBlackScreen />)}

                  />
                  <Route
                    path="/jobseeker-home"
                    element={ScreenJobseekerAfterLogin(<RecruiterHome />)}
                  />
                  <Route
                    path="/jobseeker-myJob"
                    element={ScreenJobseekerAfterLogin(<Myob />)}
                  />
                  <Route
                    path="/jobseeker-message"
                    element={ScreenJobseekerAfterLogin(<JobseekerMessage />)}
                  /> */}
                    {/* Profile */}
                    {/* <Route
                    path="/jobseeker-profile"
                    element={ScreenJobseekerAfterLogin(<Profile />)}
                  />
                  <Route
                    path="/jobseeker-calender"
                    element={ScreenJobseekerAfterLogin(<JobseekerCalendar />)}
                  />
                  
             
                 
                   */}


                    {/* <Route
            path="/"
            element={<Landing_Page />}
          /> */}
                    <Route path="/home"

                      element={
                        <LandingPage />
                      }
                    />
                    <Route path="/user-seeker-delete"

                      element={
                        <Seekeraccountdelete />
                      }
                    />



                    {/* 
                 */}


                    {/* URL Lists */}
                  </Routes>
                </HashRouter>
              </candata.Provider>
            </coinState.Provider>
          </foCredit.Provider>
        </credit_coin.Provider>
      </UserContext.Provider>

      {/* <Home/> */}
      {/* <Messages/> */}
    </>
  );
}

export default App;
export { credit_coin, coinState, UserContext, candata, foCredit }

const ScreensAfterLogin = (element) => {
  // const navigate = useNavigate();
  // const navigateToSuccess = () => {
  //   navigate("/post-vaccancy");
  //   localStorage.removeItem("vaccancy_id");
  // }
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
      /* We can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };




  return (
    <div className="main-container">
      <HeaderAfterLogin
      />
      <div className="wrapped-content-area pt-3 pb-3">{element}</div>
      <Link to="/post-vaccancy" className="fixed-new-post">
        <div
          className="flex-center"
          onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}
          // onClick={scrollToTop()}
          title="Add New Post"
          style={{ fontSize: '60px', color: '#fff' }}

        >
          {/* <img
            className="mfooter-icons"
            src="./images/postPlus.png"
            alt=""
          /> */}
          +
        </div>
      </Link>

      <Footer />
    </div>
  );
};

const ScreensBeforeLogin = (element) => {
  return (
    <div className="main-container">
      <HeaderBeforeLogin />
      <div className="wrapped-content-area loginn-outer">{element}</div>
      <Footer />
    </div>
  );
};


const ScreenJobseekerAfterLogin = (element) => {
  return (
    <div className="jobseeker-container">
      <Header />

      <div className="wrapped-content-area">{element}</div>
      <RecruiterFooter />
    </div>
  );
};
const ScreenJobseekerBeforeLogin = (element) => {
  return (
    <div className="jobseeker-container">
      <HeaderSimple />

      <div className="wrapped-content-area">{element}</div>
      <RecruiterFooter />
    </div>
  );
};
